__turbopack_context__.v({
  "actionButton": "cZSY4W_actionButton",
  "activeHeading": "cZSY4W_activeHeading",
  "activeHeadingText": "cZSY4W_activeHeadingText",
  "productListContainer": "cZSY4W_productListContainer",
  "qrModalContainer": "cZSY4W_qrModalContainer",
  "qrModalDownloadButton": "cZSY4W_qrModalDownloadButton",
  "rearrangeButtons": "cZSY4W_rearrangeButtons",
  "rearrangeButtonsContainer": "cZSY4W_rearrangeButtonsContainer",
  "rearrangeButtonsContainerThrift": "cZSY4W_rearrangeButtonsContainerThrift",
  "rearrangeModeActiveButton": "cZSY4W_rearrangeModeActiveButton",
  "seeMoreText": "cZSY4W_seeMoreText",
  "sellerLikesUsername": "cZSY4W_sellerLikesUsername",
  "shopDropWrapper": "cZSY4W_shopDropWrapper",
});
